import MonthResultInformation from "./MonthResultInformation";

export default class TeamInformation
{
    constructor (teamname, year)
    {
        this.Teamname = teamname;
        this.MonthResultInformationArray = [];

        for (let i = 1; i <= 12; i++)
        {
            this.MonthResultInformationArray.push(new MonthResultInformation(year, i));
        }
    }

    GetMonthInfo(monthNumber)
    {
        monthNumber = Math.min(12, Math.max(monthNumber, 0));
        return this.MonthResultInformationArray[monthNumber - 1];
    }
}